import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

// Tabs
import FlightReportOfflineEditTab from './Elements/FlightReportOfflineEditTab';
import FlightReportOfflineStaffsTab from './Elements/FlightReportOfflineStaffsTab';
import FlightReportOfflineLegsTab from './Elements/FlightReportOfflineLegsTab';

class FlightReportsOfflineEdit extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
      flight_type: {},
      flight_report: {},
      flight_report_legs: {},
      flight_report_leg_delays: {},
      flight_report_occurrences: {},
      flight_report_legs_totals: {},
      flight_report_approvals: {},
      flight_report_reopen_warnings: {},
      flight_report_staffs: {},
      flight_report_refuels: {},
      flight_report_logs: {},
      flight_report_warnings: {},
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: [],
      contracts_select: [],
      locations_select: [],
      staffs_select: [],
      staffs_sigmec_select: [],
      flight_report_legs_select: [],
      abnormal_occurrence_types_select: [],
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      codes_ptbr_select: [],
      duties_select: [],
      errors_messages: [],
      errors_listing: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentWillMount () {
    var flight_reports_by_id = JSON.parse(localStorage.getItem("flight_reports_by_id"));
    var flight_report_legs_lists = JSON.parse(localStorage.getItem("flight_report_legs_lists"));

    this.setState({
        flight_report_id: this.props.match.params.id, 
        flight_report: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id], 
        flight_report_staffs: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id].flight_report_leg_staffs, 
        flight_report_legs: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id].flight_report_legs,
        locations_select: flight_report_legs_lists.locations_select,
        ptbr_codes_select: flight_report_legs_lists.ptbr_codes_select,
    });
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar relatório de voo - {this.state.flight_report.report_number}</h3>
      <div className="clearfix"></div>
      <hr/>
      <FlightReportOfflineEditTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.state.flight_report_id} flight_report={this.state.flight_report}  />
      <hr/>
      <FlightReportOfflineStaffsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.state.flight_report_id} flight_report_staffs={this.state.flight_report_staffs} flight_report={this.state.flight_report} />
      <hr/>
      <FlightReportOfflineLegsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.state.flight_report_id} flight_report_legs_view={this.state.flight_report_legs} flight_report={this.state.flight_report} duties_select={this.state.duties_select} ptbr_codes_select={this.state.ptbr_codes_select} locations_select={this.state.locations_select} />
      <hr/>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsOfflineEdit;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/FlightReportsOfflineEdit.js